import { Routes } from '@angular/router';
import { StoryList } from './components/story-list/story-list';
import { StoryTags } from './create-edit-story/story-tags/story-tags';
import { authGuard } from './auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'story-list', pathMatch: 'full' },
  // Story list
  {
    path: 'story-list',
    component: StoryList,
    canActivate: [authGuard],
  },
  // Create / Edit story
  {
    path: 'create-edit-story',
    loadChildren: () => import('./create-edit-story/create-edit-story.module').then(m => m.CreateEditStoryModule),
    canActivate: [authGuard],
  },
  {
    path: 'test',
    component: StoryTags,
    canActivate: [authGuard],
  }
];
